export default __webpack_public_path__ + "static/media/Sachin_Agrawal.5424f5eb.png";